import ggf from "./ggf";

export default [
  // angle,
  // azora,
  // selfco,
  // grow
  ggf,
];
